import { CheckSetting } from "./CheckSetting";
export default CheckSetting;
